
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","stroke-opacity":"0","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.5 12a7.5 7.5 0 102.27-5.375h1.605a.75.75 0 010 1.5h-3.25a.75.75 0 01-.75-.75v-3.25a.75.75 0 011.5 0v1.28a9 9 0 11-2.842 5.82c.036-.42.401-.725.824-.725.41 0 .715.377.676.785A7.661 7.661 0 004.5 12zm8-4.25a.75.75 0 10-1.5 0v5a.75.75 0 00.75.75h2.5a.75.75 0 100-1.5H12.5V7.75z"}})])
          )
        }
      }
    